import React from "react";

import { STRING } from "@constants";
import { useAllInsurances } from "@api";
import { GenericDetailsModal, Table } from "@components";

import { useManageInsurance } from "./useManageInsurance";
import { useGetInsurances } from "./useGetInsurances";
import { getInsuranceDetails } from "./getInsuranceDetails";

const T = STRING.INSURANCE_DETAILS;

export function Insurances() {
  const { data, loading } = useAllInsurances();
  const { columns } = useGetInsurances();

  const {
    selectedInsurance,
    isDetailsModalOpen,
    handleCloseDetailsModal,
    handleRowClick,
  } = useManageInsurance();

  const { sections } = getInsuranceDetails(selectedInsurance);

  return (
    <div className="overflow-hidden">
      <GenericDetailsModal
        visible={isDetailsModalOpen}
        onHide={handleCloseDetailsModal}
        sections={sections}
        header={T.MODAL_HEADER}
        noDataText={T.NO_DATA}
      />

      <Table
        title="Insurance Plans"
        columns={columns}
        data={data}
        loading={loading}
        onRowClicked={handleRowClick}
      />
    </div>
  );
}
